import { ApplicationPrefix } from '@openx/constants/paths.ts';
import { loadInstanceName } from './oidc/oidcAuthInfo.ts';

/** Apps served under a `/<app-prefix>/<instance-slug>` basename. */
const SLUG_AWARE_APP_PREFIXES: readonly string[] = [
  ApplicationPrefix.Publisher,
  ApplicationPrefix.Dsp,
  ApplicationPrefix.Unity,
];

export function isSlugAwareApp(appPrefix: string): boolean {
  return SLUG_AWARE_APP_PREFIXES.includes(appPrefix);
}

/**
 * Prefixes an app path with the instance slug, but only for apps that are actually served under a
 * slug-aware basename. Without the guard the slug would leak into apps that do not route by instance.
 */
export function withInstanceSlug(appPrefix: string, instanceSlug?: string): string {
  return instanceSlug && isSlugAwareApp(appPrefix) ? `${appPrefix}/${instanceSlug}` : appPrefix;
}

export function withStoredInstanceSlug(appPrefix: string): string {
  return withInstanceSlug(appPrefix, loadInstanceName());
}

export function getInstanceIdFromPath(
  appPrefix: string,
  pathname: string = window.location.pathname
): string | undefined {
  const rest = pathname.startsWith(appPrefix) ? pathname.slice(appPrefix.length) : pathname;
  const [instanceId] = rest.split('/').filter(Boolean);

  return instanceId;
}

export function getBasenameWithInstanceId(appPrefix: string, pathname: string = window.location.pathname): string {
  const instanceId = getInstanceIdFromPath(appPrefix, pathname);

  return instanceId ? `${appPrefix}/${instanceId}` : appPrefix;
}
